import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-bold" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-content-end"
}

import { ref, toRefs } from 'vue';
import Dialog from 'primevue/dialog';
import { EMIT } from '@/enum';

interface PropsInterface {
  header: string;
  acceptLabel: string;
  acceptType?: string;
  rejectLabel?: string;
  disableAccept?: boolean;
  showFooter?: boolean;
  contentClass?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmAction',
  props: {
    header: {},
    acceptLabel: { default: 'Accept' },
    acceptType: { default: 'primary' },
    rejectLabel: { default: 'Cancel' },
    disableAccept: { type: Boolean, default: false },
    showFooter: { type: Boolean, default: true },
    contentClass: { default: '' }
  },
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { header, acceptLabel, acceptType, rejectLabel, contentClass, disableAccept } = toRefs(props);

const emit = __emit;

const visible = ref(true);

const accept = () => {
  emit(EMIT.ACCEPT);
  visible.value = false;
};

const cancel = () => {
  emit(EMIT.CANCEL);
  visible.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: visible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    modal: true,
    header: _unref(header),
    "content-class": _unref(contentClass),
    draggable: false,
    class: "confirm-action z-5",
    onHide: cancel
  }, {
    header: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(header)), 1)
    ]),
    footer: _withCtx(() => [
      (__props.showFooter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_AppButton, {
              text: _unref(rejectLabel),
              type: "secondary",
              onClick: cancel
            }, null, 8, ["text"]),
            _createVNode(_component_AppButton, {
              text: _unref(acceptLabel),
              type: _unref(acceptType),
              disabled: _unref(disableAccept),
              onClick: accept
            }, null, 8, ["text", "type", "disabled"])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["visible", "header", "content-class"]))
}
}

})